import { atom } from "jotai";
import { AssetType } from "../types";
import { capitalizedAssetTypeDisplayAtom } from "../utils";

export const assetStepTitlePlaceholderTextAtom = atom(
  null,
  (get, _set, assetType: AssetType) => {
    const getAssetDisplayName = get(capitalizedAssetTypeDisplayAtom);
    if (assetType) {
      return `Describe your ${getAssetDisplayName(assetType)}`;
    }
    return "Describe what happens in this step";
  },
);

assetStepTitlePlaceholderTextAtom.debugLabel =
  "assetStepTitlePlaceholderTextAtom";
